import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import '../../Ripple/Ripple';
import styles from './IconButton.scss?inline';

export const IconButtonSizeMap = {
    'extra-small': 48,
    'small': 48,
    'medium': 56,
    'large': 96,
    'extra-large': 136
}

@customElement('app-icon-button')
export class IconButton extends LitElement {
    static styles = [unsafeCSS(styles)];

    @property({ type: String, reflect: true }) k_size: 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large' = 'small';
    @property({ type: String }) k_label = '';
    @property({ type: Boolean, reflect: true }) k_disabled = false;
    @property({ type: Boolean, reflect: true }) k_morph = false;
    @property({ type: String, reflect: true }) k_colorStyle: 'filled' | 'tonal' | 'outlined' | 'standard' = 'standard';
    @property({ type: String, reflect: true }) k_width: 'default' | 'narrow' | 'wide' = 'default';
    @property({ type: String, reflect: true }) k_shape: 'round' | 'square' = 'round';

    render() {
        return html`
            <button
                aria-label=${this.k_label}
                ?disabled=${this.k_disabled}
                title=${this.k_label}
            >
                <app-ripple></app-ripple>
                <slot name='icon'></slot>
            </button>
        `
    }
}